import Cookies from 'js-cookie';

import { account } from '../utils/account';
import { GetRecaptchaToken, withRecaptcha } from '../utils/recaptcha';
import api from './api';
import apiSDK from './apiSDK';

export const HIDDEN_LOGIN_RECAPTCHA_ACTION = 'login';

export async function hiddenLogin(getToken: GetRecaptchaToken) {
  const response = await withRecaptcha(
    getToken,
    (reCaptcha) => apiSDK.session.login({ ...account, reCaptcha }, ''),
  );

  const { token } = response.data.token;
  Cookies.set('authorization', token);
  Cookies.set('userId', response.data.user.id.toString());
  api.defaults.headers.common.Authorization = `Bearer ${token}`;

  return `Bearer ${token}`;
}
